'use client'

import { zodResolver } from '@hookform/resolvers/zod'
import { get, set } from 'lodash'
import { z } from 'zod'

export const useZodResolver = () => {
  const toNestError = (error: z.ZodError) => {
    if (error instanceof z.ZodError) {
      const nestedErrors: Record<string, any> = {}
      error.errors.forEach((err) => {
        const { path, message } = err
        const currentMessage = get(nestedErrors, path)
        if (currentMessage != undefined) {
          set(nestedErrors, path, [...currentMessage, message])
        } else {
          set(nestedErrors, path, [message])
        }
      })
      return nestedErrors
    }
    return {}
  }

  // @hookform/resolversを利用すると動的なバリデーションができないので、zodResolverを参考に自作。
  const zodDynamicResolver = (zod: z.ZodObject<any> | z.ZodEffects<any>) => {
    return async (values: any) => {
      try {
        await zod.parseAsync(values)
        return { values, errors: {} }
      } catch (error) {
        return { values, errors: toNestError(error as z.ZodError) }
      }
    }
  }

  return {
    zodDynamicResolver,
    zodResolver,
  }
}
